import { useGameContainer } from '../index';
import ContentSection, { ContentSectionHeader } from '@/components/ContentSection';
import { SectionHeaderSize } from '@/components/SectionHeader';
import PhotoGalleryTile from 'components/PhotoGalleryTile';
import { localizeDate } from 'components/LocalizedDate';

export default function GameResults() {
  const [{ photoGalleries }] = useGameContainer();

  if (photoGalleries.length === 0) {
    return null;
  }

  return (
    <ContentSection>
      <ContentSectionHeader size={SectionHeaderSize.LARGE}>Game Photos</ContentSectionHeader>
      {photoGalleries.map(({ id, coverPhoto, genderSport, teams, date, photoCount, photographer, webPath, thumbnailUrl }) => (
        <PhotoGalleryTile
          key={id}
          coverImage={coverPhoto.s3Watermark ?? coverPhoto.watermark}
          genderSport={genderSport?.key ?? ''}
          teams={teams}
          dateText={localizeDate(date, 'MMMM DD, YYYY')}
          galleryCount={photoCount}
          linkUrl={webPath}
          photographer={photographer}
          thumbnailUrl={thumbnailUrl}
        />
      ))}
    </ContentSection>
  );
}
